import environments from '../../environments.json'

export type Environment = keyof typeof environments
export function isValidEnvironment(environment: any): environment is Environment {
  return environment && Reflect.has(environments, environment)
}
